import { render, staticRenderFns } from "./upload-photo.vue?vue&type=template&id=5b0c1eb8&scoped=true&"
import script from "./upload-photo.vue?vue&type=script&lang=js&"
export * from "./upload-photo.vue?vue&type=script&lang=js&"
import style0 from "./upload-photo.vue?vue&type=style&index=0&id=5b0c1eb8&scoped=true&lang=scss&"
import style1 from "./upload-photo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c1eb8",
  null
  
)

export default component.exports